<template>
    <ListadoEvento :event="event">
        <div class="m-0 text-center">
            <router-link
                v-if="!event.asientos_liberados"
                :to="{ name: 'liberar-asiento-sesion', params: { abono_id: abono_id, evento_id: event.id } }"
                class="button large-button effect-button"
            >{{ mensaje == 'Asiento liberado correctamente' || event.asientos_liberados ? $t('perfil.asiento_liberado') : $t('perfil.asiento_no_liberado') }}</router-link>
            <button v-else class="button large-button effect-button" disabled >{{ $t('perfil.asiento_liberado') }}</button>
            <p style="font-size: 10.5px; font-weight: 700; max-width: 70%;" class="mx-auto">{{ event.importe_monedero_abonado && event.importe_monedero_abonado > 0 ? $t('perfil.asiento_liberado_remobolso_texto', {importe: event.importe_monedero_abonado}) : ''}}</p>
        </div>
    </ListadoEvento>
</template>

<script>
    import ListadoEvento from '@/components/common/ListadoEvento'

    export default {
        props: ['event', 'abono_id'],
        data() {
            return {
                loading: false,
                mensaje: ''
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        components: {
            ListadoEvento
        }
    }
</script>

<style scoped>
    .info_fecha {
        margin-left: 13px; 
        margin-top: 3px;
    }

    @media (max-width: 1024px) {
        .large-button {
            width: 40wv !important;
        }
    }

    @media (max-width: 768px) {
        .info_fecha {
            margin-left: 0; 
        }
    }
</style>